import { SettingCard } from "@/app/Settings/Settings/Components/SettingFormCard";
import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";
import {
  SupplierNotificationAddRecipientButton,
  SupplierNotificationEmailList,
} from "@/app/Suppliers/Components/SupplierNotificationEmailList";
import { redirect } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

export function SettingsNotificationScreen() {
  const { supplier } = useSettingsSupplier();
  const t = useTranslations("settings.notifications");

  if (!supplier) {
    throw redirect({
      from: "/$tenant/$orgId/supplier/{-$supplierId}",
      to: "/$tenant/$orgId/supplier/{-$supplierId}/settings",
      params: (prev) => prev,
      search: (prev) => prev,
    });
  }

  return (
    <div className="space-y-12">
      <SettingCard
        title={t("title")}
        description={t("description")}
        buttons={
          <SupplierNotificationAddRecipientButton supplierId={supplier.id} />
        }
      >
        <SupplierNotificationEmailList supplier={supplier} />
      </SettingCard>
    </div>
  );
}
